export
function getQueryVariable(name, search) {
    var result = getQueryVariableSearch(name, search)
    if (!result) {
        result = getQueryVariableHash(name, search);
    }
    return result;
}

function getQueryVariableSearch(name, search) {
    search = search || window.location.search.substr(1);
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    if (search) {
        let r = search.match(reg);
        if (r != null) return unescape(r[2]);
    }
    return null;
}

function getQueryVariableHash(name, search) {
    search = search || window.location.hash.split("?")[1];
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    if (search) {
        let r = search.match(reg);
        if (r != null) return unescape(r[2]);
    }
    return null;
}

// 金额添加千分位
export
function comdify(n) {
    console.log('comify');
    if (!n) return n;
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
}

//去除千分位中的','
export
function delcommafy(num) {
    console.log('delcommafy');
    if (!num) return num;
    num = num.toString();
    num = num.replace(/,/gi, '');
    return num;
}